import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../common/AuthService";
import Loading from "../common/Loading";

export interface IProps {
  /**
   * 認証オブジェクト
   */
  authService: AuthService;
  /**
   * 認証ユーザーを設定します
   * @param {string} name - ユーザー名
   * @param {} callback - コールバック
   */
  setAuthUser: (name: string, callback?: () => void) => void;
  /**
   * 致命的なエラーの画面を表示する場合に呼び出します
   * @param status - httpステータスコード
   */
  onFatalError: (status: number | undefined) => void;
}

/**
 * 認証処理
 */
export default function LoginPage(props: IProps): JSX.Element {
  const { authService, setAuthUser, onFatalError } = props;
  const navigate = useNavigate();

  useEffect(() => {
    authService.login({
      success: (name) => {
        setAuthUser(name, () => {
          navigate("/home");
        });
      },
      fail: (status) => {
        onFatalError(status);
      },
    });
  }, []);

  return <Loading />;
}
